import { categories } from "@/mocks/categories";
import { categoryImages } from "@/mocks/categoryImages";

const catIcons: Record<string, string> = {
  "Shoes": "ri-footprint-line",
  "Hoodies": "ri-t-shirt-line",
  "TShirts": "ri-t-shirt-air-line",
  "Jackets": "ri-shirt-line",
  "Pants": "ri-checkbox-blank-circle-line",
  "Headwear": "ri-archive-line",
  "Sets": "ri-stack-line",
  "Underwear": "ri-shirt-fill",
  "Jersey": "ri-trophy-line",
  "Accessories": "ri-vip-diamond-line",
  "Bags": "ri-briefcase-4-line",
  "Belts": "ri-link",
  "Perfumes": "ri-drop-line",
  "OtherStuff": "ri-more-line",
};

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4">
            Browse Categories
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            Explore Product Categories
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            Browse our extensive catalog of verified China-sourced products across all major fashion and lifestyle categories.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative aspect-[4/5] rounded-2xl overflow-hidden cursor-pointer bg-background-100"
            >
              <img
                src={categoryImages[cat.name]}
                alt={`${cat.displayName} - AllChinaBuy Sheet`}
                title={`${cat.displayName} – China Sourcing via AllChinaBuy Spreadsheet`}
                className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
              <div className="absolute top-3 right-3">
                <span className="w-8 h-8 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-arrow-right-up-line text-white text-sm"></i>
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="flex items-center gap-2 mb-1">
                  <span className="w-7 h-7 rounded-md bg-white/20 backdrop-blur-sm flex items-center justify-center flex-shrink-0">
                    <i className={`${catIcons[cat.name] || "ri-price-tag-3-line"} text-white text-xs`}></i>
                  </span>
                </div>
                <span className="text-white font-heading font-semibold text-sm md:text-base leading-tight">
                  {cat.displayName}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}